export default "__VITE_ASSET__DJN8KT2u__"